module.exports = __webpack_public_path__ + "static/media/N_Menu.f84ac986.png";